export default {
  computed: {
    $rules: function () {
      const validate = (predicate, invalidMessageKey) => {
        return (value) => (predicate(value) || this.$root.$t(invalidMessageKey))
      }
      return {
        isRequired: validate(
          value => (Boolean(value) || value === 0),
          'ValidationRules.isRequired'
        ),
        isValidFloat: validate(
          value => (/^[0-9,.]+$/.test(value)),
          'ValidationRules.isValidFloat'
        ),
        isValidEmail: validate(
          value => value ? Boolean(/(?!^[.+&'_-]*@.*$)(^[_\w\d+&'-]+(\.[_\w\d+&'-]*)*@[\w\d-]+(\.[\w\d-]+)*\.(([\d]{1,3})|([\w]{2,}))$)/.test(value)) : true,
          'ValidationRules.isValidEmail'
        ),
        isValidPassword: validate(
          value => Boolean(value.length >= 8),
          'ValidationRules.isValidPassword'
        ),
        isPasswordMatch: validate(
          value => Boolean(value[0] === value[1]),
          'ValidationRules.isPasswordMatch'
        ),
        isValidNumber: validate(
          value => Boolean(/^[0-9]+$/.test(value)),
          'ValidationRules.isValidNumber'
        ),
        isPercent: validate(
          value => Number(value) >= 0 && Number(value) <= 100,
          'ValidationRules.isPercent'
        ),
        isMinEightChars: validate(
          value => Boolean(value.length >= 8) || false,
          'ValidationRules.isMinEightChars'
        )
      }
    }
  }
}
